<template>
  <section class="evolved-section">
    <div class="section-container">

      <!-- 标题区域 (整体缩小) -->
      <div class="header">
        <div class="tag">OUR JOURNEY</div>
        <h2 class="title">How We <span class="gradient">Evolved</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 主体内容区：左右两栏 -->
      <div class="content-wrapper">

        <!-- 左侧：垂直时间线 -->
        <div class="timeline">
          <div v-for="(event, index) in events" :key="index" class="timeline-item">
            <div class="node"></div>
            <div class="event-content">
              <div class="phase">{{ event.phase }}</div>
              <h3 class="event-title">{{ event.title }}</h3>
              <p class="event-desc">{{ event.desc }}</p>
              <div class="badge" :class="{ 'current': event.isCurrent }">
                <span class="badge-dot"></span> {{ event.badge }}
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：终端卡片与指标面板 -->
        <div class="cards-area">

          <!-- 卡片 1：操作终端 -->
          <div class="panel terminal-panel">
            <div class="panel-header">
              <div class="dots">
                <span class="dot red"></span>
                <span class="dot yellow"></span>
                <span class="dot green"></span>
              </div>
              <span class="panel-title">FCD_OPERATIONS.log</span>
            </div>

            <div class="terminal-body">
              <p v-for="(line, idx) in terminalLines" :key="idx">
                <span :class="line.type">{{ line.text }}</span>
              </p>
              <!-- 添加闪烁光标 -->
              <p class="cmd-line">
                <span class="cmd">$</span> <span class="cursor">▊</span>
              </p>
            </div>

            <div class="terminal-stats">
              <div class="t-stat">
                <div class="t-num">147</div>
                <div class="t-label">LIVE TRACES</div>
              </div>
              <div class="t-stat">
                <div class="t-num">18</div>
                <div class="t-label">NETWORKS</div>
              </div>
            </div>
          </div>

          <!-- 卡片 2：成功率指标 -->
          <div class="panel metrics-panel">
            <div class="metrics-title">CASE SUCCESS METRICS</div>

            <div class="metrics-list">
              <div v-for="metric in metrics" :key="metric.name" class="metric-item">
                <div class="m-header">
                  <span class="m-name">{{ metric.name }}</span>
                  <span class="m-value">{{ metric.value }}%</span>
                </div>
                <div class="m-bar">
                  <div class="m-fill" :style="{ width: metric.value + '%' }"></div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'EvolvedSection',
  data() {
    return {
      events: [
        {
          phase: 'FOUNDED',
          title: 'Fraud Counsel Department Established',
          desc: 'Founded by a coalition of blockchain investigators and cybercrime specialists who identified the critical lack of specialist support for crypto fraud victims worldwide.',
          badge: 'MILESTONE',
          isCurrent: false
        },
        {
          phase: 'YEAR ONE',
          title: 'First 500 Cases Reviewed',
          desc: 'In our first year of operations we reviewed over 500 cases across 12 countries, establishing our evidence-based forensic methodology and legal enforcement protocols.',
          badge: 'MILESTONE',
          isCurrent: false
        },
        {
          phase: 'EXPANSION',
          title: 'Global Enforcement Network Built',
          desc: 'Established formal relationships with international cybercrime units, financial regulators, and major cryptocurrency exchanges across 30+ countries to accelerate recovery outcomes.',
          badge: 'MILESTONE',
          isCurrent: false
        },
        {
          phase: 'TODAY',
          title: '5,000+ Cases — $1.83M Recovered',
          desc: 'Now operating as a globally recognised leader in cryptocurrency recovery, with a 94.7% case closure rate and clients in over 40 countries trusting us with their most critical cases.',
          badge: 'CURRENT',
          isCurrent: true
        }
      ],
      terminalLines: [
        { text: '$ init global_scan --all-networks', type: 'cmd' },
        { text: '> Connected to 18 blockchain networks', type: 'out' },
        { text: '$ load_case_database', type: 'cmd' },
        { text: '> 5,247 cases loaded successfully', type: 'out' },
        { text: '$ run_forensic_trace --active', type: 'cmd' },
        { text: '> 147 active traces running', type: 'out' },
        { text: '$ check_recovery_status', type: 'cmd' },
        { text: '> $1,838,000+ recovered this campaign', type: 'warn' },
        { text: '$ report --format legal_grade', type: 'cmd' }
      ],
      metrics: [
        { name: 'CRYPTO FRAUD', value: 92 },
        { name: 'INVESTMENT', value: 87 },
        { name: 'BROKER SCAM', value: 95 },
        { name: 'ROMANCE', value: 89 },
        { name: 'DEFI / NFT', value: 84 }
      ]
    };
  }
}
</script>

<style scoped>
.evolved-section {
  background-color: #070b14;
  padding: 60px 5%;
  /* 减小外层间距 */
  color: #e2e8f0;
  /* 整体变淡的颜色 */
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  position: relative;
  margin-bottom: 50px;
  /* 减小标题区与内容区的间距 */
}

.tag {
  color: #4fd1c5;
  /* 淡青色 */
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.5rem;
  /* 标题缩小 */
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
  /* 线条变淡 */
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 主体内容区 */
.content-wrapper {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 60px;
  /* 减小左右两栏的间距 */
}

/* --- 左侧时间线 --- */
.timeline {
  position: relative;
  padding-left: 20px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 7px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: rgba(79, 209, 197, 0.4);
  /* 线变淡 */
}

.timeline-item {
  position: relative;
  margin-bottom: 30px;
  /* 段落间隔缩小 */
}

.node {
  position: absolute;
  left: -22px;
  top: 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #4fd1c5;
  /* 节点变淡 */
  background: #070b14;
  z-index: 2;
}

.event-content {
  padding-top: 5px;
}

.phase {
  color: #4fd1c5;
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 10px;
}

.event-title {
  font-size: 1.2rem;
  /* 标题缩小 */
  font-weight: 600;
  margin: 0 0 15px;
}

.event-desc {
  color: #a0b3cc;
  font-size: 0.9rem;
  /* 正文缩小 */
  line-height: 1.6;
  margin-bottom: 15px;
  /* 间距缩小 */
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #000;
  border: 1px solid #334155;
  /* 边框变淡 */
  padding: 5px 10px;
  font-size: 0.7rem;
  /* 字体缩小 */
  font-weight: 600;
  letter-spacing: 1px;
}

.badge-dot {
  width: 6px;
  height: 6px;
  background: #4fd1c5;
}

.badge.current {
  border-color: #b8860b;
  color: #b8860b;
}

.badge.current .badge-dot {
  background: #b8860b;
}

/* --- 右侧终端与指标面板 --- */
.cards-area {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid #253045;
  /* 边框变淡 */
  border-radius: 8px;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: #0d1117;
  border-bottom: 1px solid #253045;
}

.dots {
  display: flex;
  gap: 6px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.panel-title {
  color: #a0b3cc;
  font-family: monospace;
  font-size: 0.8rem;
  margin-left: 10px;
}

.terminal-body {
  padding: 15px;
  font-family: monospace;
  font-size: 0.85rem;
  /* 终端字体缩小 */
  line-height: 1.8;
  /* 行高稍微压缩 */
}

.cmd {
  color: #4fd1c5;
}

.out {
  color: #a0b3cc;
}

.warn {
  color: #ffbd2e;
}

/* 光标闪烁动画 */
.cursor {
  color: #4fd1c5;
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.terminal-stats {
  display: flex;
  justify-content: space-around;
  background: #0a101f;
  padding: 15px;
  border-top: 1px solid #253045;
}

.t-stat {
  text-align: center;
}

.t-num {
  color: #4fd1c5;
  font-size: 1.6rem;
  /* 数据字体缩小 */
  font-weight: 700;
  margin-bottom: 5px;
}

.t-label {
  color: #a0b3cc;
  font-size: 0.7rem;
  /* 标签缩小 */
  letter-spacing: 1px;
}

/* 面板：指标 */
.metrics-panel {
  padding: 20px;
}

.metrics-title {
  color: #a0b3cc;
  font-family: monospace;
  font-size: 0.75rem;
  /* 标题缩小 */
  margin-bottom: 20px;
}

.metric-item {
  margin-bottom: 15px;
  /* 指标间距缩小 */
}

.m-header {
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 0.75rem;
  /* 指标字体缩小 */
  font-weight: 600;
  margin-bottom: 8px;
}

.m-value {
  color: #4fd1c5;
}

.m-bar {
  height: 5px;
  /* 进度条变细 */
  background: #1f2937;
  border-radius: 3px;
  overflow: hidden;
}

.m-fill {
  height: 100%;
  background: #4fd1c5;
  /* 进度条变淡 */
  border-radius: 3px;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .timeline {
    padding-left: 20px;
  }

  .timeline::before {
    left: 5px;
  }

  .node {
    left: -17px;
  }

  .title {
    font-size: 2rem;
  }
}
</style>